import * as React from "react";

import { cn } from "@/lib/utils";

interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  src?: string | null;
  alt?: string;
  fallback?: string;
  size?: "sm" | "md" | "lg";
}

export const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(
  ({ className, src, alt = "", fallback, size = "md", ...props }, ref) => {
    const [errored, setErrored] = React.useState(false);
    const sizeClass = {
      sm: "h-6 w-6 text-[10px]",
      md: "h-8 w-8 text-xs",
      lg: "h-10 w-10 text-sm",
    }[size];

    return (
      <div
        ref={ref}
        className={cn(
          "relative flex shrink-0 overflow-hidden rounded-full bg-muted",
          sizeClass,
          className,
        )}
        {...props}
      >
        {src && !errored ? (
          <img
            src={src}
            alt={alt}
            onError={() => setErrored(true)}
            className="h-full w-full object-cover"
          />
        ) : (
          <span className="flex h-full w-full items-center justify-center font-medium text-muted-foreground">
            {fallback ?? alt.slice(0, 2).toUpperCase()}
          </span>
        )}
      </div>
    );
  },
);
Avatar.displayName = "Avatar";
